import MeetUsWrapper from "Components/MeetUsWrapper";
import React from "react";
import styles from "./style.module.scss";
import CheckCircle2 from "../../../Utils/Assets/Images/CheckCircle2.png";

const workData = [
    {
        id: 1,
        title: "Complete brand-sponsored tasks, surveys, and challenges.",
        features: [
            "Complete brand-sponsored tasks, surveys, and challenges.",
            "Participate in MeetusVR events and product promotions.",
            "Refer users and grow your brand influence score.",
        ],
    },
    {
        id: 2,
        title: "Stake MVR Influence Coins to Unlock Perks",
        description: "The more you stake, the higher your level & the more benefits you unlock.",
        inlineFeatures: true,
        features: [
            "Cashback on transactions",
            "VIP brand ambassador perks",
            "Access to exclusive VR brand deals",
        ],
    },
    {
        id: 3,
        title: "Move Up the Influencer Ladder",
        levels: [
            { level: "Level 1", mvr: "222,222 MVR", multiplier: "1x", reward: "5% fee discount, 1% cashback" },
            { level: "Level 2", mvr: "888,889 MVR", multiplier: "2x", reward: "5% fee discount, 2% cashback, local influencer status" },
            { level: "Level 3", mvr: "3,555,556 MVR", multiplier: "3x", reward: "15% fee discount, 3% cashback, influencer status" },
            { level: "Level 4", mvr: "10,666,667 MVR", multiplier: "4.5x", reward: "25% fee discount, 5% cashback, Top influencer status" },
            { level: "Level 5", mvr: "32,000,000", multiplier: "6x", reward: "40% fee discount, 8% cashback, VR Celebrity status", highlight: true },
        ],
    },
];

const HowWork = () => {
    return (
        <div className={styles.howWorkWrapper}>
            <MeetUsWrapper>
                <div className={styles.howWorkContent}>
                    <h1 className={styles.title}>How it Work</h1>
                    <div className={styles.stepsContainer}>
                        {workData.map((item) => (
                            <div key={item.id} className={styles.workCard}>
                                <div className={styles.cardHeader}>
                                    <div className={styles.numberCircle}>
                                        {item.id}
                                    </div>
                                    <div>
                                        <h2 className={styles.cardTitle}>{item.title}</h2>
                                        {item.description && (
                                            <p className={styles.cardDescription}>{item.description}</p>
                                        )}
                                    </div>
                                </div>
                                {item.features && (
                                    <div className={`${styles.featuresList} ${item.inlineFeatures ? styles.featuresListInline : ""}`}>
                                        {item.features.map((feature, idx) => (
                                            <div key={idx} className={styles.featureItem}>
                                                <img src={CheckCircle2} alt="check" className={styles.checkIcon} />
                                                <span>{feature}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {item.levels && (
                                    <div className={styles.levelsTable}>
                                        <div className={styles.tableHeader}>
                                            <span>Level</span>
                                            <span>MVR Staked</span>
                                            <span>Multiplier</span>
                                            <span>Reward & Perks</span>
                                        </div>
                                        {item.levels.map((lvl, idx) => (
                                            <div key={idx} className={`${styles.levelRow} ${lvl.highlight ? styles.highlight : ""}`}>
                                                <div className={styles.levelCol}>
                                                    <span className={styles.colLabel}>Level</span>
                                                    <span className={styles.colVal}>{lvl.level}</span>
                                                </div>
                                                <div className={styles.levelCol}>
                                                    <span className={styles.colLabel}>MVR Staked</span>
                                                    <span className={styles.colVal}>{lvl.mvr}</span>
                                                </div>
                                                <div className={styles.levelCol}>
                                                    <span className={styles.colLabel}>Multiplier</span>
                                                    <span className={styles.colVal}>{lvl.multiplier}</span>
                                                </div>
                                                <div className={styles.levelCol}>
                                                    <span className={styles.colLabel}>Reward & Perks</span>
                                                    <span className={styles.colVal}>{lvl.reward}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default HowWork;
